// extracted by mini-css-extract-plugin
module.exports = {"Heading":"_1w2yh","Stat":"_3NGnZ","Dt":"_3eX3p","Dd":"_2goNX","NoMargin":"_3Dnzz"};